import React from 'react';

function Preisliste() {
  return (
    <div className="container mx-auto px-6 py-16">
      <h2 className="text-3xl font-bold text-center mb-8">Pakete</h2>

      {/* 2 Karten pro Reihe */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Karte 1 */}
        <div className="relative bg-white p-6 shadow-lg rounded-lg hover:shadow-xl transition-shadow duration-300 flex flex-col">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-2xl font-bold">Bring-Your-Drinks-Paket</h2>
            <span className="inline-block bg-green-100 text-green-800 text-lg font-semibold px-3 py-1 rounded-full">
              ab 200&nbsp;€
            </span>
          </div>
          <ul className="list-disc list-inside text-gray-700 mb-6 flex-grow">
            <li>Cocktailmaschine HUGO</li>
            <li>Lieferung, Aufbau, Einweisung, Abbau, Abholung, Reinigung</li>
            <li>Gläser in passender Anzahl</li>
            <li>Digitale Cocktailkarte mit Such- und Filterfunktion</li>

          </ul>
          <div className="mb-6">
            <p className="text-gray-700 font-semibold mb-2">Auf Anfrage und nach Verfügbarkeit:</p>
            <ul className="list-disc list-inside text-gray-700 ml-4">
              <li>Cocktailservietten</li>
              <li>Edelstahl-Strohhalme</li>
              <li>Eiswürfel</li>
              <li>Markensäfte & Markenspirituosen</li>
            </ul>
          </div>
          <a href="#anfrage" className="mt-auto inline-block text-center">
            <button className="w-full bg-green-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-green-700 transition-colors duration-200">
              Jetzt anfragen
            </button>
          </a>
        </div>

        {/* Karte 2 */}
        <div className="relative bg-white p-6 shadow-lg rounded-lg hover:shadow-xl transition-shadow duration-300 flex flex-col">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-2xl font-bold">All-Inclusive-Paket</h2>
            <span className="inline-block bg-blue-100 text-blue-800 text-lg font-semibold px-3 py-1 rounded-full">
              Preis auf Anfrage
            </span>
          </div>
          <ul className="list-disc list-inside text-gray-700 mb-6 flex-grow">
            <li>Cocktailmaschine HUGO</li>
            <li>Lieferung, Aufbau, Einweisung, Abbau, Abholung, Reinigung</li>
            <li><strong>100 Cocktails inklusive!</strong></li>
            <li>Gläser in passender Anzahl</li>
            <li>Edelstahl-Strohhalme in passender Anzahl</li>
            <li>Eiswürfel in ausreichender Menge</li>
            <li>Cocktailservietten</li>
            <li>Digitale Cocktailkarte mit Such- und Filterfunktion</li>
            <li>Markensäfte und Markenspirituosen für alle Cocktails</li>
          </ul>
          <a href="#anfrage" className="mt-auto inline-block text-center">
            <button className="w-full bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors duration-200">
              Jetzt anfragen
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Preisliste;
